import {RootState} from '../rootReducer';

export const customSettingsSelector = (state: RootState) => state.customSettings;
